import customersSlice from './customersSlice';

export * from './thunks';

export default customersSlice;
